import { render, staticRenderFns } from "./DownloadNew.vue?vue&type=template&id=32c37fd3&scoped=true"
import script from "./DownloadNew.vue?vue&type=script&lang=js"
export * from "./DownloadNew.vue?vue&type=script&lang=js"
import style0 from "./DownloadNew.vue?vue&type=style&index=0&id=32c37fd3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c37fd3",
  null
  
)

export default component.exports